'use client'

import { useRouter } from 'next/navigation'
import { useCallback, useEffect, useState } from 'react'

import { Footer, OTPInput, Tips } from '@/components/index'
import { MOENGAGE_EVENT_NAME, trackMoengageEvent } from '@/libs/configs/moengage'
import { useAppSelector } from '@/libs/hooks/use-app-selector'
import useCookies, { ECookies } from '@/libs/hooks/use-cookies'

export default function SetupPINPage() {
  const { push } = useRouter()
  const { set } = useCookies()
  const { partnerId } = useAppSelector((state) => state.user)

  const [pin, setPin] = useState<string>('')

  const { forgotKey, changeProfileSource } = useCookies()

  const handleSubmit = useCallback(() => {
    if (pin.length === 6) {
      set(ECookies.tempPIN, pin)

      if (!forgotKey && !changeProfileSource) {
        trackMoengageEvent(MOENGAGE_EVENT_NAME.CREATE_REGISTER_PIN)
      }

      return push('/auth/register/confirm-pin')
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pin])

  useEffect(() => {
    handleSubmit()
  }, [handleSubmit, pin])

  return (
    <main className='flex flex-row'>
      <div className='mx-auto md:flex-grow'>
        <form className='mx-auto flex flex-col gap-4 px-5 py-4 md:w-1/2 md:py-6 lg:w-1/2 lg:py-9 xl:w-1/3 xl:py-12'>
          <h1 className='text-center text-2xl font-semibold text-pop-neutral'>
            Set Up {partnerId ? 'New' : 'Responova'} PIN
          </h1>
          <p className='text-center text-sm font-light text-pop-neutral'>
            Set up a 6-digit PIN for quick and secure access to your account.
          </p>
          <div className='flex flex-col gap-7'>
            <OTPInput onChange={(e) => setPin(e)} />
          </div>
          <Tips
            title='Security Tips:'
            tipsList={[
              'Avoid using easily guessable patterns or sequences.',
              'Do not share your PIN with anyone.',
            ]}
          />
          <Footer />
        </form>
      </div>
    </main>
  )
}
